import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id: mid, pagination }) => {
        const { page, pageSize: limit } = pagination;
        try {
            const [envsRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listEnvironments', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listEnvironments', {
                    mid: mid === undefined ? [] : mid
                })
            ]);

            if (envsRes.error || selectedRes.error) {
                throw new Error(envsRes.msg || selectedRes.msg);
            }

            const environments = { data: envsRes.data, count: envsRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = environments.data.find(
                    itemEnvironment => itemEnvironment.mid === itemSelected.mid
                );
                if (!item) {
                    environments.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return environments;
        } catch (err) {
            console.error(err);
        }
    }
};
